exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.section[data-v-ec3e2364] {\n  background-color: #50aadb;\n}\n.section .content-container[data-v-ec3e2364] {\n    width: 925px;\n    margin: 32px auto 80px auto;\n}\n@media all and (max-width: 1200px) {\n.section .content-container[data-v-ec3e2364] {\n      width: 80%;\n}\n}\n@media all and (max-width: 960px) {\n.section .content-container[data-v-ec3e2364] {\n      width: calc(100% - 120px);\n}\n}\n@media all and (max-width: 768px) {\n.section .content-container[data-v-ec3e2364] {\n      width: calc(100% - 70px);\n}\n}\n@media all and (max-width: 480px) {\n.section .content-container[data-v-ec3e2364] {\n      width: calc(100% - 60px);\n}\n}\n@media all and (max-width: 320px) {\n.section .content-container[data-v-ec3e2364] {\n      width: calc(100% - 40px);\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-ec3e2364","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/postcss-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SectionQuestion.vue
// module id = 378
// module chunks = 0